import { TagType } from '@myre/common-tag';
import { TranslatePipe } from '@myre/ui-primitive-core';
import { TooltipComponent } from '@myre/ui-primitive-tooltip';

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';

import { ActionButtonComponent } from '../../buttons/action-button/action-button.component';
import { TagComponent } from '../../tag/tag.component';

import { type CalendarEvent } from '../myre-calendar/myre-calendar.interface';
import { MyreEventCalendarEventComponent } from '../myre-event-calendar-event/myre-event-calendar-event.component';
import { type EventCalendarDay } from '../myre-month-view/myre-month-view.interface';

@Component({
  selector: 'myre-event-calendar-popup',
  templateUrl: './myre-event-calendar-popup.component.html',
  styleUrls: ['./myre-event-calendar-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TagComponent,
    TooltipComponent,
    MyreEventCalendarEventComponent,
    ActionButtonComponent,
    TranslatePipe,
  ],
})
export class MyreEventCalendarPopupComponent implements OnChanges {
  @Input()
  public eventCalendarDay: EventCalendarDay;

  @Input()
  public canEdit: boolean = false;

  @Input()
  public isOpen: boolean;

  @Output()
  public onEventCreated = new EventEmitter<Date>();

  @Output()
  public onEventUpdated = new EventEmitter<CalendarEvent>();

  @Output()
  public onClosePopups = new EventEmitter<boolean>();

  public TagTypeEnum: typeof TagType = TagType;

  @ViewChild('morePopup', { static: false })
  public morePopup: ElementRef;

  @ViewChild('moreRef', { static: false })
  public moreRef: ElementRef;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isOpen) {
      this.isOpen = changes.isOpen.currentValue;
    }
  }

  public trackByFnc(_: number, event: CalendarEvent): number {
    return event.id;
  }

  public onEventCreatedClick(date: Date): void {
    this.isOpen = false;
    this.onClosePopups.emit(false);
    this.onEventCreated.emit(date);
  }

  public onEventUpdatedEmit(event: CalendarEvent): void {
    this.isOpen = false;
    this.onClosePopups.emit(false);
    this.onEventUpdated.emit(event);
  }

  public onMoreClick(): void {
    this.isOpen = true;
    this.onClosePopups.emit(true);
  }
}
